import { Component, contentChild, input, signal, TemplateRef } from '@angular/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';

@Component({
  selector: 'app-step',
  imports: [HlmButtonImports],
  template: `<ng-content />`,
})
export class StepComponent {
  readonly content = contentChild(TemplateRef<any>);
  readonly label = input.required<string>();
  readonly active = signal(false);
}
